import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { FaUpload, FaTimes } from "react-icons/fa";

const DropzoneUpload = ({ label, onDrop, previews = [], onRemove, multiple = false, disabled }) => {
  const handleDrop = useCallback(
    (acceptedFiles) => {
      onDrop(acceptedFiles);
    },
    [onDrop]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: handleDrop,
    accept: { "image/*": [] },
    multiple,
    disabled,
  });

  return (
    <div className="mb-4">
      <label className="block mb-2 font-medium">{label}</label>
      <div className="">
         <div
        {...getRootProps()}
        className={`flex flex-col items-center justify-center border-2 border-dashed rounded-md p-6 transition cursor-pointer ${
          isDragActive ? "border-blue-500" : "border-gray-300"
        } ${disabled && "opacity-50 cursor-not-allowed"}`}
      >
        <input {...getInputProps()} />
        <FaUpload className="text-3xl text-gray-400 mb-2" />
        <p className="text-gray-600">
          {isDragActive ? "Drop files here..." : "Drag files to upload or click to browse"}
        </p>
      </div>

      <div className="mt-3 flex justify-between flex-wrap gap-2">
        {previews.map((src, index) => (
          <div key={index} className="relative w-20 h-20">
            <img src={src} alt={`Preview ${index}`} className="w-full h-full object-cover rounded" />
            {!disabled && (
              <button
                type="button"
                className="absolute top-0 right-0 bg-black bg-opacity-50 text-white text-xs rounded-full px-1"
                onClick={() => onRemove(index)}
              >
                <FaTimes />
              </button>
            )}
          </div>
        ))}
      </div>
      </div>
     
    </div>
  );
};

export default DropzoneUpload;
